// extracted by mini-css-extract-plugin
export default {"container":"ChooseLangModal_container__F7Z9v","overlay":"ChooseLangModal_overlay__NCiVT","buttons":"ChooseLangModal_buttons__YBHfd"};